import { type User, useAuth } from "@assetwatch/auth";
import { post } from "aws-amplify/api";
import { useFeatureFlags } from "../components/LaunchDarkly/useFeatureFlags";
import config from "../config";
import {
  assertCanAccessMlFrontend,
  type MlFrontendAccessFlags,
} from "../lib/access";

const API_NAME = "ML_API";

export type MlSandboxResponse = unknown;

type MlSandboxRequest = {
  meth: "print_hello_world";
};

function sandboxUrl() {
  return `${config.mlApi.baseUrl}${config.mlApi.sandboxPath}`;
}

export async function callMlSandbox(
  user: User | null,
  flags: MlFrontendAccessFlags,
): Promise<MlSandboxResponse> {
  const request: MlSandboxRequest = { meth: "print_hello_world" };

  assertCanAccessMlFrontend({ flags, user });

  const { body } = await post({
    apiName: API_NAME,
    path: config.mlApi.sandboxPath,
    options: { body: request },
  }).response;

  return body.json() as Promise<MlSandboxResponse>;
}

export function getMlSandboxUrl() {
  return sandboxUrl();
}

export function useMlSandboxApi() {
  const { user } = useAuth();
  const flags = useFeatureFlags();

  return {
    callMlSandbox: () => callMlSandbox(user, flags),
    getMlSandboxUrl,
  };
}
